export const PERMISSION = {
  CARD_COLLECTION: "read:card_collection",
  PATIENT_AR: "read:patient_ar",
  FINANCIAL_AGGREGATE: "read:financial_aggregate",
} as const;

export type Permission = (typeof PERMISSION)[keyof typeof PERMISSION];

/** A required permission with a wildcard action or resource, e.g. `read:*`. */
export type WildcardPermission = `${string}:*` | `*:${string}`;

export type AnyPermission = Permission | WildcardPermission;

/**
 * Same rule as admin's `matchesPermission` and the backend's
 * `EvalTokenPermission`: wildcards appear only in the required permission;
 * granted permissions are concrete `action:resource` names.
 */
export function matchesPermission(
  grantedPermission: string,
  requiredPermission: string,
): boolean {
  if (!requiredPermission.includes("*")) {
    return grantedPermission === requiredPermission;
  }

  const [requiredAction, requiredResource] = requiredPermission.split(":");
  const [grantedAction, grantedResource] = grantedPermission.split(":");

  return (
    (requiredAction === "*" || requiredAction === grantedAction) &&
    (requiredResource === "*" || requiredResource === grantedResource)
  );
}
